import React from 'react';
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";
import { BsFillPersonLinesFill } from "react-icons/bs"

const SocialLinks = () => {
    const links = [
        {
            id: 1,
            child: (
                <>
                    LinkedIn <FaLinkedin size={30} className='ml-2' />
                </>
            ),
            href: 'https://www.linkedin.com/in/devashish-biswas-8722a7209',
            style: 'rounded-tr-md'
        },
        {
            id: 2,
            child: (
                <>
                    GitHub   <FaGithub size={30} className='ml-5' />
                </>
            ),
            href: 'https://github.com/DEVELOPER22DEVASHISH',

        },
        {
            id: 3,
            child: (
                <>
                    Mail   <HiOutlineMail size={35} className='ml-10' />
                </>
            ),
            href: 'mailto:devashishbiswas11@gmail.com',
            // style: 'rounded-tr-md'
        },
        {
            id: 4,
            child: (
                <>
                    Resume <BsFillPersonLinesFill size={30} className='ml-3' />
                </>
            ),
            href: '/Devashish Resume for Software engineering.pdf',
            style: 'rounded-br-md',
            download: true,
        },
    ]
    return (
        <div className="hidden lg:flex flex-col top-[35%] left-0 fixed">
            <ul>

                {links.map(({ id, child, href, download }) => (
                    <li key={id} className={"flex justify-between items-center mx w-40 h-14 px-6 ml-[-100px] hover:ml-[-10px] hover:rounded-md duration-300 bg-gray-500"}>
                        <a href={href} className="flex justify-center items-center w-full text-white  "
                            download={download}
                            //  target blank allows to open new tag
                            target='_blank'
                            rel='noreferrer'

                        >


                            {child}

                        </a>
                    </li>

                ))}

            </ul>
        </div>
    )
}

export default SocialLinks